import React from 'react';
import {Avatar, Button, Chip, Tooltip, Typography} from "@mui/material";
import {authLogout} from "../../../../../services/AuthServices";
import multiavatar from "@multiavatar/multiavatar";
import {getAccountInfo, getUserEmail, getUserNameAndSurname} from "../../../../../utils/GenericUtils";
import SVG from "react-inlinesvg";
import {roles} from "../../../../../utils/dictionaries/Roles";
import {HomeStyle} from "../../../../../styles/pages/home/HomeStyle";
import {useHistory} from "react-router-dom";

export const ProfiloPaper = () => {
	const classes = HomeStyle();
	const history = useHistory();
	const account = getAccountInfo() || {};
	const fullName = getUserNameAndSurname();
	const email = getUserEmail();
	const displayName = fullName && !fullName.includes("Errore") ? fullName : account.alias || account.username;
	const displayEmail = email && !email.includes("Errore") ? email : account.username;

	return (
		<section className={classes.card}>
			<header className={classes.cardHeader}>
				<div>
					<Typography className={classes.cardTitle}>Profilo</Typography>
					<Typography className={classes.cardSubtitle}>
						Identita, ruoli e accesso rapido alle impostazioni.
					</Typography>
				</div>
			</header>

			<div className={classes.profileBlock}>
				<Avatar className={classes.profileAvatar}>
					<SVG src={multiavatar(account.username || "atlantis")}/>
				</Avatar>
				<div>
					<Typography className={classes.actionName}>
						{displayName}
					</Typography>
					<Typography className={classes.actionDescription}>
						{displayEmail}
					</Typography>
					<div className={classes.roleStack}>
						{account.roles?.slice(0, 5).map((role) => (
							<Tooltip key={role} title={roles[role] ? roles[role].label : role}>
								<Chip
									size="small"
									label={roles[role]?.label || role.replace("ROLE_", "")}
									style={{
										backgroundColor: roles[role] ? roles[role].color : "var(--atl-surface-muted)",
										color: roles[role] ? roles[role].textCol : "var(--atl-text)",
									}}
								/>
							</Tooltip>
						))}
					</div>
				</div>
			</div>

			<div className={classes.cardFooter}>
				<Button variant="outlined" onClick={() => history.push("/gestione/profilo")}>
					Profilo
				</Button>
				<Button variant="contained" disableElevation onClick={() => authLogout()}>
					Logout
				</Button>
			</div>
		</section>
	);
};
